/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file AlbuminuriaProgressView.jsx
 * @author Daniel Aguirre
 * @description AlbuminuriaProgress View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * AlbuminuriaProgress View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function AlbuminuriaProgressView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getAlbuminuriaProgress } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Empeora',
        color: styleGuideColors.alertError
      },

      {
        label: 'Estable',
        color: styleGuideColors.baxterBrandBaxterBlue
      },

      {
        label: 'Mejora',
        color: styleGuideColors.baxterBrandTeal
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ variacion }) => variacion === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getAlbuminuriaProgress({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const { label: variacion, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/albuminuria-progress/${variacion}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F14" loading={!chartData}>
      <DashboardDoughnut
        title={translate('dashboardStaff.albuminuriaProgress')}
        dataValues={chartData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
AlbuminuriaProgressView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getAlbuminuriaProgress: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default AlbuminuriaProgressView;
